import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="mt-24"
      style={{ borderTop: "1px solid #B8B2A6" }}
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16 pt-12 pb-8">
        {/* Top row — Logo · Navigate · Contact */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8 items-start">
          <div className="lg:col-span-6">
            <img
              src="https://customer-assets-jt897jd0.emergentagent.net/job_luxury-institute/artifacts/j0je1nsj_NIL-Gold1.png"
              alt="Next in Luxury"
              className="w-full max-w-[280px]"
              style={{ height: "auto" }}
              data-testid="footer-logo"
            />
          </div>

          <div className="lg:col-span-3">
            <p className="font-eyebrow opacity-60">Navigate</p>
            <ul className="mt-5 space-y-2.5 font-body text-sm">
              <li><Link to="/the-house" className="editorial-link" data-testid="footer-link-house">The House</Link></li>
              <li><Link to="/manifesto" className="editorial-link" data-testid="footer-link-manifesto">Manifesto</Link></li>
              <li><Link to="/services" className="editorial-link" data-testid="footer-link-services">Services</Link></li>
              <li><Link to="/expert-minds" className="editorial-link" data-testid="footer-link-experts">Expert Minds</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="font-eyebrow opacity-60">Contact</p>
            <ul className="mt-5 space-y-2.5 font-body text-sm">
              <li>
                <a
                  href="mailto:hello@nextinluxury.com"
                  className="editorial-link"
                  data-testid="footer-email"
                >
                  Email
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="editorial-link"
                  data-testid="footer-whatsapp"
                >
                  WhatsApp
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom row */}
        <div
          className="mt-14 pt-6 flex flex-col md:flex-row justify-between items-center gap-3 font-eyebrow opacity-60 text-[10px]"
          style={{ borderTop: "1px solid #B8B2A6" }}
        >
          <span>© {new Date().getFullYear()} Next in Luxury. All rights reserved.</span>
          <span>Discretion. Distinction.</span>
        </div>
      </div>
    </footer>
  );
}
